import { toUtcDateTime } from '@kernel';

import { type Notifications, NotificationType } from './notifications.types';

const FACILITY = 'Hall Of Justice';

const RELATIVE_OFFSETS_MS = [10_000, 60_000, 2 * 3_600_000, 86_400_000, 7 * 86_400_000] as const;

function withRelativeCreatedDates<T extends { readonly created: string }>(
  items: readonly T[],
): T[] {
  return items.map((item, index) => ({
    ...item,
    created: toUtcDateTime(
      new Date(Date.now() - RELATIVE_OFFSETS_MS[index % RELATIVE_OFFSETS_MS.length]),
    ),
  }));
}

export function createNotificationsMock(): Notifications[] {
  return withRelativeCreatedDates([
    {
      id: 1001,
      subject: 'Prior-auth denied — Margarethe Olsen',
      body: 'The payer returned the requested therapy as not covered. Needs a new auth or a therapeutic swap.',
      created: '',
      type: NotificationType.ALERT,
      document_id: 401922,
      requires_review: true,
      opened: false,
      facility: FACILITY,
    },
    {
      id: 1002,
      subject: 'Cycle 14 delivery moved to 2 Sep',
      body: 'The courier rescheduled. Your check-in window shifts with it.',
      created: '',
      type: NotificationType.NOTIFICATION,
      document_id: 398777,
      requires_review: false,
      opened: false,
      facility: FACILITY,
    },
    {
      id: 1003,
      subject: 'Census uploaded for August',
      body: '42 residents, 3 changes since July.',
      created: '',
      type: NotificationType.NOTIFICATION,
      document_id: 880119,
      requires_review: false,
      opened: true,
      facility: FACILITY,
    },
    {
      id: 1004,
      subject: 'Invoice #8821 marked paid',
      body: '$372 cleared across 3 payments.',
      created: '',
      type: NotificationType.NOTIFICATION,
      document_id: 8821,
      requires_review: false,
      opened: true,
      facility: FACILITY,
    },
    {
      id: 1005,
      subject: 'Prescription awaiting approval',
      body: 'Dr. Alvarez submitted a new prescription for review.',
      created: '',
      type: NotificationType.ALERT,
      document_id: 402118,
      requires_review: true,
      opened: true,
      facility: FACILITY,
    },
  ]);
}
